import { useState, useEffect } from 'react';
import { deviceApprovalsService } from '../services/device-approvals-api-service';

const POLL_INTERVAL_MS = 30000;

/**
 * Returns the count of pending device approvals for sidebar badge.
 * Polls every 30s. Does not block render; defaults to 0.
 *
 * `enabled` gates polling to roles that may actually read the approvals
 * endpoint (admin). Scoped roles (report-viewer, monitor) get a 403 there,
 * so skip the call entirely to avoid noise.
 */
export function usePendingApprovalsCount(enabled = true) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!enabled) {
      setCount(0);
      return undefined;
    }

    let cancelled = false;

    const fetchCount = async () => {
      try {
        const data = await deviceApprovalsService.getPendingApprovals();
        const list = Array.isArray(data) ? data : [];
        if (!cancelled) setCount(list.length);
      } catch {
        if (!cancelled) setCount(0);
      }
    };

    fetchCount();
    const interval = setInterval(fetchCount, POLL_INTERVAL_MS);
    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, [enabled]);

  return count;
}

export default usePendingApprovalsCount;
